/* eslint-disable react/prop-types */
import React from 'react';
import GroupGrid from '../GroupGrid';
import SearchUser from './SearchUser';
import { Container } from './styles';

function Card({
  loading,
  isSelected,
  setLoading,
  setIsSelected,
  nomeUser,
  setForm,
  form,
}) {
  return (
    <Container>
      <h1>Grupo usuário</h1>
      <SearchUser
        loading={loading}
        setIsSelected={setIsSelected}
        setLoading={setLoading}
        setForm={setForm}
        form={form}
      />
      {isSelected ? (
        <GroupGrid
          loading={loading}
          setLoading={setLoading}
          nomeUser={nomeUser}
        />
      ) : (
        ''
      )}
    </Container>
  );
}

export default Card;
